import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Drawer,
  TextField,
  Checkbox,
  MenuItem,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import Select from "react-select";
import {
  IoCalendarOutline,
  IoCloseSharp,
  IoFilter,
  IoFilterOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import HolidayTableView from "./HolidayTableView";
import dayjs from "dayjs";
import { IoIosArrowBack, IoIosArrowForward, IoIosMore } from "react-icons/io";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme } from "../../../style/theme";
import { FiGrid } from "react-icons/fi";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { RiDeleteBin6Line, RiDeleteBinLine } from "react-icons/ri";
import { CgClose } from "react-icons/cg";
import axios from "axios";
import { toast } from "react-toastify";
import { MdEdit, MdOutlineEdit } from "react-icons/md";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CustomModal from "../../../components/CustomModal";
import { CiExport, CiImport } from "react-icons/ci";
import { X } from "lucide-react";
import ExportModal from "../../../components/ExportModal";
import ImportModal from "../../../components/ImportModal";
import * as XLSX from "xlsx";
import { useMessage } from "../../../components/Header";
export default function Holidays() {
  const [switchScreen, setSwitchScreen] = useState({ primary: "tableView" });
  const [holidays, setHolidays] = useState();
  const [addHolidayModal, setAddHolidayModel] = useState(false);
  const [viewHolidayModal, setViewHolidayModal] = useState(false);
  const [editHolidayModal, setEditHolidayModal] = useState(false);
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [openCalendar, setOpenCalendar] = useState(false);
  const startOfWeek = selectedDate.startOf("isoWeek"); // Monday
  const endOfWeek = startOfWeek.add(6, "day"); // Sunday
  // const formattedStart = startOfWeek.format("DD/MM/YYYY");
  // const formattedEnd = endOfWeek.format("DD/MM/YYYY");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedHolidayId, setSelectedHolidayId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [filterModal, setFilterModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [hide, setHide] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  console.log("🚀 ~ Holidays ~ year:", year);
  const [exportOpen, setExportOpen] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredHolidays, setFilteredHolidays] = useState([]);
  const [holidayDates, setHolidayDates] = useState(new Set());
  const [selectedFile, setSelectedFile] = useState(null);
  const { showSuccess, showError } = useMessage();
  const currentOrg = JSON.parse(localStorage.getItem("org"));
  const currentemp = JSON.parse(localStorage.getItem("emp"));
  //   const startOfYear = year.startOf("year");     // 1st January
  // const endOfYear = year.endOf("year");         // 31st December

  // const formattedStart = startOfYear.format("DD/MM/YYYY");
  // const formattedEnd = endOfYear.format("DD/MM/YYYY");

  const getYearDateRange = (year) => {
    const start = dayjs(`${year}-01-01`);
    const end = dayjs(`${year}-12-31`);
    return {
      formattedStart: start.format("DD/MM/YYYY"),
      formattedEnd: end.format("DD/MM/YYYY"),
    };
  };

  const { mode } = useTheme();

  const calendarRef = useRef(null);
  useEffect(() => {
    if (calendarRef.current && dateRange.start) {
      const calendarApi = calendarRef.current.getApi();
      const startDate = new Date(dateRange.start);
      calendarApi.gotoDate(startDate);
    }
  }, [dateRange]);

  const getHolidayDates = (holidays) => {
    const dates = new Set();

    holidays.forEach((holiday) => {
      const from = new Date(holiday.fromDate);
      const to = new Date(holiday.toDate);
      let current = new Date(from);

      while (current <= to) {
        dates.add(new Date(current).toDateString()); // Sirf date part
        current.setDate(current.getDate() + 1); // agla din
      }
    });
    return dates;
  };

  const getHolidayDatesWithNames = (holidays) => {
    const dateMap = new Map();

    holidays.forEach((holiday) => {
      const from = new Date(holiday.fromDate);
      const to = new Date(holiday.toDate);
      let current = new Date(from);

      while (current <= to) {
        const dateStr = current.toDateString();
        if (!dateMap.has(dateStr)) {
          dateMap.set(dateStr, []);
        }
        dateMap.get(dateStr).push(holiday.name);
        current.setDate(current.getDate() + 1);
      }
    });

    return dateMap;
  };

  const fetchHolidays = async (newYear) => {
    try {
      const response = await axios.get(`/hr/leaveHoliday/filter/${newYear}/${currentOrg?._id}`);
      setHolidays(response.data);
      console.log("🚀 ~ fetchHolidays ~ response:", response)
      setFilteredHolidays(response.data);
      const dateMap = getHolidayDatesWithNames(response.data);
      setHolidayDates(dateMap); // ab yeh Map hai
    } catch (error) {
      console.error("Error fetching holidays", error);
    }
  };

  useEffect(() => {
    fetchHolidays(new Date().getFullYear().toString());
    getYearDateRange(new Date().getFullYear().toString());
  }, []);

  const deleteHoliday = async (id) => {
    try {
      const res = await axios.delete(`/hr/leaveHoliday/${id}`);
      console.log(res.data.message); 
    } catch (error) {
      console.error("Failed to delete holiday", error);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedHolidayId) return;

    await deleteHoliday(selectedHolidayId);
    setDeleteModalOpen(false);
    setHolidays((prev) =>
      prev.filter((holiday) => holiday._id !== selectedHolidayId)
    );
    fetchHolidays(new Date().getFullYear().toString());
    // Optionally: refresh table/list here
  };

  const handlePrevYear = () => {
    const newYear = (parseInt(year) - 1).toString();
    setYear(newYear);
    fetchHolidays(newYear);
  };

  const handleNextYear = () => {
    const newYear = (parseInt(year) + 1).toString();
    setYear(newYear);
    fetchHolidays(newYear);
  };

  const { formattedStart, formattedEnd } = getYearDateRange(year);

  const handlePrevWeek = () => {
    setSelectedDate(selectedDate.subtract(7, "day"));
  };

  const handleNextWeek = () => {
    setSelectedDate(selectedDate.add(7, "day"));
  };

  const [currentMonth, setCurrentMonth] = useState(dayjs());

  const handlePrevMonth = () => {
    setCurrentMonth(currentMonth.subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentMonth(currentMonth.add(1, "month"));
  };

  const daysInMonth = currentMonth.daysInMonth();
  const firstDay = currentMonth.startOf("month").day();

  const calendarDays = [];
  for (let i = 0; i < firstDay; i++) {
    calendarDays.push(null);
  }
  for (let i = 1; i <= daysInMonth; i++) {
    calendarDays.push(i);
  }

  const AddHolidayModal = ({
    setAddHolidayModel,
    addHolidayModal,
    editData,
  }) => {
    const [shiftVisible, setShiftVisible] = useState();
    const [criteriaRows, setCriteriaRows] = useState([]);
    const { register, handleSubmit, control, setValue, watch, reset } = useForm(
      {
        defaultValues: {
          name: "",
          fromDate: "",
          toDate: "",
          restricted: false,
          reminderDays: "",
          notifyEmployees: true,
          reprocessLeaves: false,
          locationCriteria: [],
        },
      }
    );

    const locationOptions = ["All Locations", "Lahore", "Karachi"].map((v) => ({
      label: v,
      value: v,
    }));
    const shiftOptions = ["All Shifts", "General"].map((v) => ({
      label: v,
      value: v,
    }));
    const days = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30,
    ].map((v) => ({ label: v, value: v }));

    useEffect(() => {
      if (editData) {
        reset({
          name: editData?.name,
          fromDate: editData?.fromDate,
          reminderDays: editData?.reminderDays
            ? { label: editData.reminderDays, value: editData.reminderDays }
            : null,
          description: editData?.description,
          dateDetails: editData?.dateDetails,
          toDate: editData?.toDate,
          notifyEmployees: editData?.notifyEmployees,
          reprocessLeaves: editData?.reprocessLeaves,
          restricted: editData?.restricted,
        });

        setFromDate(editData?.fromDate ?? "");
        setToDate(editData?.toDate ?? "");

        // 🛠️ Set criteriaRows based on editData
        if (editData?.criteria?.length > 0) {
          const type = editData.criteria[0].type;
          const field = type.toLowerCase();

          // 🧠 Set criteriaRows (important for rendering the field)
          setCriteriaRows([{ type, field }]);

          // 🧠 Set selected value
          const values = editData.criteria[0].value
            .split(",")
            .map((v) => ({ label: v.trim(), value: v.trim() }));

          setValue(field, type === "Shift" ? values[0] : values);
        } else {
          setCriteriaRows([]);
        }
      } else {
        reset(); // 👈 Clear form on Add mode
        setFromDate("");
        setToDate("");
        setCriteriaRows([]);
      }
    }, [editData, reset, setValue]);
    console.log(editData, "editDataeditData");

    const onSubmit = async (data) => {
      try {
        const criteria = criteriaRows.map((row) => {
          const selectedValues = data[row.field];

          let value = "";
          if (Array.isArray(selectedValues)) {
            value = selectedValues.map((v) => v.value).join(",");
          } else if (selectedValues?.value) {
            value = selectedValues.value;
          }

          return {
            type: row.type,
            value,
          };
        });

        const payload = {
          name: data?.name,
          fromDate,
          toDate,
          reminderDays: data?.reminderDays?.value ?? null,
          description: data?.description || "",
          criteria,
          dateDetails: dateList,
          notifyEmployees: data?.notifyEmployees,
          reprocessLeaves: data?.reprocessLeaves,
          restricted: data?.restricted,
          orgId: currentOrg?._id
        };

        if (editData?._id) {
          // 🔄 Update holiday
          await axios.put(`/hr/leaveHoliday/${editData._id}`, payload);
          showSuccess("Holiday updated successfully");
        } else {
          // ➕ Create new holiday
          await axios.post(`/hr/leaveHoliday`, payload);
          showSuccess("Holiday created successfully");
        }

        setAddHolidayModel(false);
        setEditData(null);
        fetchHolidays(new Date().getFullYear().toString());
      } catch (error) {
        console.error("Error submitting holiday:", error);
        toast.error("Something went wrong!");
      }
    };

    console.log(editData, "editDataeditData");

    const handleDeleteCriteria = (index) => {
      const updatedRows = [...criteriaRows];
      updatedRows.splice(index, 1);
      setCriteriaRows(updatedRows);
    };

    const addCriteria = () => {
      const existingTypes = criteriaRows.map((row) => row.type);
      if (!existingTypes.includes("Location")) {
        setCriteriaRows([
          ...criteriaRows,
          { type: "Location", field: "location" },
        ]);
      } else if (!existingTypes.includes("Shift")) {
        setCriteriaRows([...criteriaRows, { type: "Shift", field: "shift" }]);
      }
    };

    const timeOptions = ["Full Day", "1st half", "2nd half"];

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dateList, setDateList] = useState([]);

    // Generate date range whenever fromDate or toDate changes
    useEffect(() => {
      if (fromDate && toDate && dayjs(toDate).isAfter(fromDate)) {
        const start = dayjs(fromDate);
        const end = dayjs(toDate);
        const days = [];

        for (
          let d = start;
          d.isBefore(end.add(1, "day"));
          d = d.add(1, "day")
        ) {
          days.push({ date: d.format("ddd DD-MMM-YYYY"), type: "Full Day" });
        }
        setDateList(days);
      } else {
        setDateList([]);
      }
    }, [fromDate, toDate]);

    return (
      <Drawer
        anchor="right"
        open={addHolidayModal}
        onClose={() => setAddHolidayModel(false)}
        PaperProps={{
          className: "w-[99%] m-1 md:w-[650px] lg:w-[800px] rounded-lg",
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="h-full flex flex-col"
        >
          <div className="h-full bg-gray-200 flex flex-col relative">
            {/* Header */}
            <div
              className={`${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
                }  px-4 py-2 flex justify-between items-center sticky top-0 z-10`}
            >
              <h2 className="text-[18px] font-semibold">Add Holidays</h2>
              <div
                className={`${mode === "light" ? "bg-[#dcdcdc]" : ""
                  } p-2 rounded-md cursor-pointer`}
                onClick={() => setAddHolidayModel(false)}
              >
                <CgClose />
              </div>
            </div>

            {/* Content */}
            <div
              className={`${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
                }  overflow-y-auto p-4`}
            >
              <div
                style={{
                  backgroundColor: mode === "light" ? "#fff" : "#171717",
                }}
                className="px-5 py-4 rounded-md flex flex-col justify-between gap-5 "
              >
                {/* Name Field */}
                <div className="flex flex-col gap-2">
                  <label className="block text-[14px] font-[500] mt-4">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="text"
                        fullWidth
                        size="small"
                      />
                    )}
                  />
                </div>

                {/* Time Fields */}
                <div>
                  <div className="flex gap-2 items-center w-full">
                    <div className="w-full flex-1">
                      <label className="block text-[14px] font-[500] mt-4">
                        From <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        className={`border p-2 rounded w-[280px] ${mode === "light" ? "bg-white" : "bg-transparent"
                          }`}
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>

                    <div className="w-full flex-1">
                      <label className="block text-[14px] font-[500] mt-4">
                        To <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        className={`border p-2 rounded w-[280px] ${mode === "light" ? "bg-white" : "bg-transparent"
                          }`}
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Generated List */}
                  {dateList?.length > 0 && (
                    <div
                      className={`${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
                        } w-[400px] p-2 mt-2 rounded-md`}
                    >
                      {dateList.map((item, index) => (
                        <div
                          key={index}
                          className="flex justify-between items-center"
                        >
                          <span>{item.date}</span>
                          <TextField
                            select
                            size="small"
                            value={item.type}
                            onChange={(e) => {
                              const updatedList = [...dateList];
                              updatedList[index].type = e.target.value;
                              setDateList(updatedList);
                            }}
                          >
                            {timeOptions.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Restricted Checkbox */}
                <Controller
                  name="restricted"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field.value} />}
                      label="Restricted"
                    />
                  )}
                />

                {/* Criteria Section */}
                <div>
                  <label className="block text-[14px] font-[500] mb-2">
                    Applicable for
                  </label>

                  {criteriaRows.length > 0 && (
                    <div
                      className={`${mode === "light" ? "bg-[#edf0f4]" : "bg-[#171717]"
                        } px-2 py-2 rounded-md w-[482px] flex flex-col gap-2`}
                    >
                      {criteriaRows.map((row, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-4 w-full mb-2"
                        >
                          <div
                            className={`${mode === "light" ? "bg-[#fff]" : "bg-[#141414]"
                              }
                           px-2 py-2 rounded-md w-[126px] h-[33px] flex flex-col justify-center items-center`}
                          >
                            {row.type}
                          </div>
                          <div>
                            <Controller
                              name={row.field}
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={
                                    row.type === "Location"
                                      ? locationOptions
                                      : shiftOptions
                                  }
                                  placeholder="Select"
                                  isClearable
                                  isMulti={row.type === "Location"}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      height: "30px",
                                      minHeight: "30px",
                                      width: "270px",
                                      backgroundColor:
                                        mode === "light" ? "#fff" : "#141414",
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: "30px",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      height: "30px",
                                      padding: "0 6px",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      backgroundColor:
                                        mode === "light" ? "#fff" : "#141414",
                                    }),
                                  }}
                                />
                              )}
                            />
                          </div>
                          <div
                            onClick={() => handleDeleteCriteria(index)}
                            className="cursor-pointer"
                          >
                            <RiDeleteBinLine />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {criteriaRows.length < 2 && (
                    <div className="mt-3">
                      <Button variant="outlined" onClick={addCriteria}>
                        Add Criteria
                      </Button>
                    </div>
                  )}
                </div>

                {/* Description */}
                <div className="flex flex-col gap-2">
                  <label className="block text-[14px] font-[500] mt-4">
                    Description
                  </label>
                  <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="text"
                        fullWidth
                        size="small"
                      />
                    )}
                  />
                </div>

                {/* Days Selector */}
                <div className="flex flex-col gap-2">
                  <label className="block text-[14px] font-[500] mt-4">
                    No of day(s) before when the reminder email is to be sent
                  </label>
                  <Controller
                    name="reminderDays"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={days}
                        placeholder="Select"
                        isClearable
                        styles={{
                          control: (base) => ({
                            ...base,
                            height: "40px",
                            minHeight: "40px",
                            backgroundColor:
                              mode === "light" ? "#fff" : "#141414",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "40px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "40px",
                            padding: "0 6px",
                          }),
                          menu: (base) => ({
                            ...base,
                            backgroundColor:
                              mode === "light" ? "#fff" : "#141414",
                          }),
                        }}
                      />
                    )}
                  />
                </div>

                {/* Notify Employees */}

                <Controller
                  name="notifyEmployees"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field.value} />}
                      label="Notify applicable employees via feeds"
                    />
                  )}
                />

                <small>
                  (They will receive a feed notification instantly once this
                  holiday is saved)
                </small>

                {/* Reprocess Leaves */}

                <Controller
                  name="reprocessLeaves"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field.value} />}
                      label="Reprocess leave applications based on this added holiday"
                    />
                  )}
                />
                <small>
                  (Leaves that are already applied for this holiday will be
                  reprocessed and the balance will be adjusted accordingly)
                </small>

                <div
                  className={`${mode === "light" ? "bg-[#fff7e5]" : "bg-[#141414]"
                    } rounded-md p-2 mt-4 mb-4`}
                >
                  <b>Note</b> : Shift based holiday will override the location
                  based holiday.
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              className={`sticky flex gap-3 items-center top-0 ${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
                }  z-10 py-4 px-4`}
            >
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: "#0088ff" }}
              >
                {editData ? "Update" : "Submit"}
              </Button>
              <button
                style={{
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                }}
                className="w-[79px] h-[36px] rounded-md"
                onClick={() => setAddHolidayModel(false)}
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Drawer>
    );
  };

  const FilterDrawer = () => {
    const normalizeDate = (dateStr) => {
      const date = new Date(dateStr);
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const applyFilters = () => {
      if (!fromDate || !toDate) return;

      const from = normalizeDate(fromDate);
      const to = normalizeDate(toDate);

      const filtered = holidays.filter((holiday) => {
        const holidayFrom = normalizeDate(holiday.fromDate);
        const holidayTo = normalizeDate(holiday.toDate);

        return holidayFrom <= to && holidayTo >= from;
      });

      setFilteredHolidays(filtered);
      setFilterModal(false);
    };

    const resetFilters = () => {
      setFromDate("");
      setToDate("");
      setFilteredHolidays(holidays); // show all data again
      setFilterModal(false);
    };
    return (
      <Drawer
        anchor="right"
        open={filterModal}
        onClose={() => setFilterModal(false)}
      >
        <div
          style={{
            backgroundColor: mode === "light" ? "#fff" : "#141414",
          }}
          className="w-72 p-4 h-full flex flex-col justify-between"
        >
          <div>
            <div className="flex justify-between items-center">
              <h2 className="text-lg font-semibold mb-4">Filter</h2>
              <button
                className="border-none outline-none"
                onClick={() => setFilterModal(false)}
              >
                <X size={20} />
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-2">
              Showing {filteredHolidays.length} holidays.
            </p>

            <div className="mt-4">
              <label className="block text-sm font-medium mb-1">
                From Date
              </label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className={`border rounded px-3 p-1 w-full
    ${mode === "light"
                    ? "text-black bg-white"
                    : "text-white bg-[#1f1f1f] border-gray-600"
                  }`}
              />
            </div>

            <div className="mt-4">
              <label className="block text-sm font-medium mb-1">To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className={`border rounded px-3 p-1 w-full
    ${mode === "light"
                    ? "text-black bg-white"
                    : "text-white bg-[#1f1f1f] border-gray-600"
                  }`}
              />
            </div>
          </div>

          <div className="flex justify-start mt-4 space-x-2">
            <Button variant="contained" onClick={applyFilters}>
              Apply
            </Button>
            <Button variant="outlined" onClick={resetFilters}>
              Reset
            </Button>
          </div>
        </div>
      </Drawer>
    );
  };

  const holidayTypes = [
    "My Holiday",
    "All Holiday",
    "My Shifts",
    "General",
  ].map((v) => ({
    label: v,
    value: v,
  }));

  const { control } = useForm();

  const ViewModal = ({ open, data, onClose, onEdit, setModalOpen }) => {
    const formatTimeRange = (from, to) => {
      const f = new Date(`1970-01-01T${from}:00Z`);
      const t = new Date(`1970-01-01T${to}:00Z`);
      return `${f.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })} - ${t.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    };

    return (
      <Drawer
        PaperProps={{
          className:
            "w-[99%] m-1 md:w-[650px] lg:w-[800px] rounded-lg relative",
        }}
        anchor="right"
        open={open}
        onClose={onClose}
      >
        <div className="h-full  flex flex-col relative">
          <div
            className={`${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
              }  px-4 py-2 flex justify-between items-center sticky top-0 z-10`}
          >
            <h4 variant="h4">Compensatory Request</h4>
            <div className="flex gap-2 items-center">
              {currentOrg?.type == "Owner" && (
                <div
                  onClick={onEdit}
                  className={`p-2 rounded-md ${mode === "light" ? "bg-[#fff]" : "bg-[#141414]"
                    } cursor-pointer`}
                >
                  <MdEdit />
                </div>
              )}

              <div
                onClick={() => setModalOpen(false)}
                className={`p-2 rounded-md ${mode === "light" ? "bg-[#DCDCDC]" : "bg-[#141414]"
                  } cursor-pointer`}
              >
                <IoCloseSharp />
              </div>
            </div>
          </div>

          <div
            className={`${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
              } flex-1 overflow-y-auto p-4`}
          >
            <div
              className="p-4 rounded-md"
              style={{
                backgroundColor: mode === "light" ? "#fff" : "#171717",
              }}
            >
              <p className="flex flex-col mb-[20px] text-sm">
                <label Duration={`block text-[14px] font-[500] mb-2 mt-4`}>
                  Name <span className="text-red-500">*</span>
                </label>

                <p>{data?.name}</p>
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <label Duration={`block text-[14px] font-[500] mb-2 mt-4`}>
                  Date <span className="text-red-500">*</span>
                </label>
                <div>
                  <span>
                    {data?.dateDetails?.length > 0 && (
                      <>
                        {
                          // Format utility function
                          (() => {
                            const formatDate = (dateStr) => {
                              const d = new Date(dateStr);
                              return d
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .replace(/ /g, "-");
                            };

                            const startDate = formatDate(
                              data.dateDetails[0].date
                            );
                            const endDate = formatDate(
                              data.dateDetails[data.dateDetails.length - 1].date
                            );

                            return `${startDate} - ${endDate}`;
                          })()
                        }
                      </>
                    )}
                  </span>
                  <br />
                  {data?.dateDetails?.map((item, i) => (
                    <div key={i} style={{ marginTop: "20px" }}>
                      <div>{item.date}</div>
                      <div
                        style={{
                          height: "6px",
                          backgroundColor: "#d3d3d3",
                          borderRadius: "4px",
                          position: "relative",
                          overflow: "hidden",
                          marginTop: "4px",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            backgroundColor: "#2196f3",
                            width: item.type === "Full Day" ? "100%" : "50%",
                            marginLeft: item.type === "2nd Half" ? "50%" : "0",
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Locations:</p>
                {data?.criteria?.map((loc, i) => (
                  <span key={i}>{loc?.value || loc?.value || "N/A"}</span>
                ))}
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Shifts:</p>
                {data?.criteria?.map((loc, i) => (
                  <span key={i}>{loc?.value || loc?.value || "N/A"}</span>
                ))}
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Description:</p>
                <p>{data?.description}</p>
              </p>
            </div>
          </div>

          <div
            className={`sticky flex gap-3 items-center top-0 ${mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
              }  z-10 py-4 px-4`}
          >
            <button
              className="rounded-md w-[67px] h-[31px] text-sm"
              onClick={() => setModalOpen(false)}
              style={{
                border: "1px solid #ededed",
                color: mode === "light" ? "#000" : "#fff",
                background: mode === "light" ? "#fff" : "#141414",
              }}
            >
              Close
            </button>
          </div>
        </div>
      </Drawer>
    );
  };

  const handleExportCSV = () => {
    const holidayData = holidays; // Replace this with your actual data variable

    const headers = [
      "Name",
      "From Date",
      "To Date",
      "Location",
      "Description",
      "Dates",
    ];
    const rows = holidayData.map((item) => {
      const allDates = item.dateDetails?.map((d) => d.date).join(", ");
      return [
        item.name,
        new Date(item.fromDate).toDateString(),
        new Date(item.toDate).toDateString(),
        item.location || "-", // Optional: in case some don't have location
        item.description || "-",
        allDates,
      ];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "holidays_export.csv");
    document.body.appendChild(link);
    link.click();
  };
  const formatHolidayExportData = (data) => {
    return data?.map((item) => {
      const dates = item.dateDetails
        ?.map((d) => {
          const date = new Date(d?.date);
          const options = {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric",
          };
          const [weekday, rest] = date
            .toLocaleDateString("en-GB", options)
            .split(", ");
          return `${rest.replace(/ /g, "-")} (${weekday})`;
        })
        .join(", ");

      const locations = item.criteria?.map((c) => c?.value || "N/A").join(", ");

      return {
        Name: item.name,
        "Date(s)": dates,
        "Location(s)": locations,
        Shifts: "-",
        Description: item.description,
      };
    });
  };

  const exportData = formatHolidayExportData(filteredHolidays);

  const handleClose = () => {
    setOpenImportModal(false);
    setSelectedFile(null);
  };

  const handleDone = () => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const grouped = {};
      let hasInvalidRow = false;

      jsonData?.forEach((row, index) => {
        console.log("🚀 ~ jsonData?.forEach ~ row:", row);
        let fromDate = row["From Date"];
        let toDate = row["To Date"];
        const dateStr = row["Date(s)"];
        const location = row["Location(s)"];

        let dateDetails = [];

        // If from/to not present, extract from Date(s)
        if (!fromDate && !toDate && dateStr) {
          const dateParts = dateStr
            .split(",")
            .map((part) => {
              const match = part.trim().match(/^(\d{2}-[A-Za-z]{3}-\d{4})/);
              return match ? match[1] : null;
            })
            .filter(Boolean);

          if (dateParts.length === 1) {
            fromDate = toDate = dateParts[0];
          } else if (dateParts.length >= 2) {
            fromDate = dateParts[0];
            toDate = dateParts[1];
          }

          dateDetails = dateParts.map((d) => ({ date: d }));
        }

        if (!fromDate || !toDate) {
          showError(
            `❌ Row ${index + 2}: Missing both From/To Date or valid Date(s).`
          );
          hasInvalidRow = true;
          return;
        }

        if (!grouped[row.Name]) {
          grouped[row.Name] = {
            name: row.Name,
            fromDate,
            toDate,
            reminderDays: row["Reminder Days"],
            description: row.Description || "",
            criteria: [],
            dateDetails: [...dateDetails],
            notifyEmployees:
              row["Notify Employees"]?.toString().toLowerCase() === "true",
            reprocessLeaves:
              row["Reprocess Leaves"]?.toString().toLowerCase() === "true",
            restricted:
              row["Restricted"]?.toString().toLowerCase() === "true",
          };

          // Push Location criteria (if available)
          if (location) {
            grouped[row.Name].criteria.push({
              type: "Location",
              value: location,
            });
          }
        }

        // Add other criteria
        if (row["Criteria Type"] && row["Criteria Value"]) {
          grouped[row.Name].criteria.push({
            type: row["Criteria Type"],
            value: row["Criteria Value"],
          });
        }

        // Add original dateDetails (if provided separately)
        if (row["Date"]) {
          grouped[row.Name].dateDetails.push({ date: row["Date"] });
        }
      });

      if (hasInvalidRow) return;

      const finalPayloads = Object.values(grouped).map((h) => ({
        ...h,
        criteria: Array.from(
          new Map(h.criteria.map((item) => [item.type + item.value, item])).values()
        ), // remove duplicates
      }));

      finalPayloads.forEach(async (payload) => {
        try {
          await axios.post("/hr/leaveHoliday", payload);
          showSuccess("File imported successfully!");
          fetchHolidays(new Date().getFullYear().toString());
        } catch (err) {
          console.error("Upload failed for:", payload.name, err);
        }
      });

      handleClose();
    };

    if (selectedFile) {
      reader.readAsArrayBuffer(selectedFile);
    }
  };


  return (
    <div className="w-full h-full flex flex-col p-4 gap-3">
      <div className="w-full flex gap-3 flex-col md:flex-row justify-between md:items-center">
        <div />
        <div />

        <div className="flex relative items-center gap-2 ">
          {/* Previous Week Button */}
          <div
            className={`flex items-center gap-2 ${mode === "light" ? "bg-white" : "bg-transparent"
              } p-2 rounded-md`}
          >
            <IoIosArrowBack
              fontSize="small"
              className="cursor-pointer hover:text-gray-600"
              onClick={() => {
                switchScreen.primary === "calendarView"
                  ? handlePrevMonth()
                  : handlePrevYear();
              }}
              color="#398aff"
            />

            {/* Calendar Icon and Date Range Text */}
            <Box className="relative flex items-center rounded-md cursor-pointer hover:bg-gray-200">
              <IoCalendarOutline
                // onClick={() => setOpenCalendar(!openCalendar)}
                size="18px"
                className="text-gray-600"
              />
            </Box>

            {/* Next Week Button */}
            <IoIosArrowForward
              fontSize="small"
              className="cursor-pointer hover:text-gray-600"
              onClick={() => {
                switchScreen.primary === "calendarView"
                  ? handleNextMonth()
                  : handleNextYear();
              }}
              color="#398aff"
            />
          </div>

          {switchScreen.primary === "calendarView" ? (
            <span className="text-sm font-semibold">
              {currentMonth.format("MMMM YYYY")}
            </span>
          ) : (
            <span className="text-sm font-medium">
              {formattedStart} - {formattedEnd}
            </span>
          )}

          {/* Calendar Popup */}
          {/* {openCalendar && (
            <Box
              className="absolute top-8 z-10 shadow-md border rounded-md "
              sx={{ backgroundColor: mode === "dark" ? "#171717" : "white" }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  value={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    setOpenCalendar(false);
                  }}
                />
              </LocalizationProvider>
            </Box>
          )} */}
        </div>

        <div className="flex gap-2 items-center">
          <div
            className={`rounded-md flex items-center gap-1  ${mode === "light" ? "bg-[#fff]" : ""
              }`}
          >
            <div
              className="relative group p-1 rounded-md"
              style={{
                border:
                  switchScreen.primary === "tableView"
                    ? "1px solid #0088ff"
                    : "",
              }}
            >
              <FiGrid
                size={20}
                className="cursor-pointer"
                onClick={() => {
                  setSwitchScreen({ primary: "tableView" });
                  setHide(false);
                }}
                color={switchScreen.primary === "tableView" ? "#0088ff" : ""}
              />
              <span className="absolute top-10 left-1/2 w-[max-content] -translate-x-1/2 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                Table view
              </span>
            </div>
            <div
              className="relative group p-1 rounded-md"
              style={{
                border:
                  switchScreen.primary === "calendarView"
                    ? "1px solid #0088ff"
                    : "",
              }}
            >
              <IoCalendarOutline
                size={20}
                className="cursor-pointer"
                onClick={() => {
                  setSwitchScreen({ primary: "calendarView" });
                  setHide(true);
                }}
                color={switchScreen.primary === "calendarView" ? "#0088ff" : ""}
              />
              <span className="absolute top-10 left-1/2 -translate-x-1/2 w-[max-content] text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                Calendar view
              </span>
            </div>
          </div>
          <div>
            <Controller
              name="holidayTypes"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={holidayTypes}
                  placeholder="Select"
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "32px",
                      minHeight: "32px",
                      width: "200px",
                      backgroundColor: mode === "light" ? "#fff" : "#141414",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "32px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "32px",
                      padding: "0 6px",
                    }),
                    menu: (base) => ({
                      ...base,
                      backgroundColor: mode === "light" ? "#fff" : "#141414",
                    }),
                  }}
                />
              )}
            />
          </div>
          {currentOrg?.type == "Owner" && (
            <div>
              <Button
                onClick={() => {
                  setEditData(null);
                  setAddHolidayModel(true);
                }}
                variant="contained"
                sx={{ height: "32px" }}
              >
                Add Holiday
              </Button>
            </div>
          )}

          {!hide && (
            <IconButton
              onClick={() => {
                setFilterModal(true);
              }}
              className="cursor-pointer"
            >
              <IoFilterOutline size={17} />
              <span className="absolute left-1/2 -translate-x-1/2 text-xs w-[max-content] bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                Filter
              </span>
            </IconButton>
          )}

          {!hide && (
            <div
              className={`relative group p-2 rounded-md ${mode === "light" ? "bg-[#fff]" : ""
                }`}
              onClick={() => setIsOpen(!isOpen)}
            >
              <IoIosMore size={17} className="cursor-pointer" />
              {isOpen && (
                <Box
                  sx={{
                    backgroundColor: mode === "light" ? "#fff" : "#363636",
                  }}
                  className="absolute w-[150px] z-40 right-3 shadow-md p-5 flex flex-col gap-2 rounded-lg top-10"
                >
                  {currentOrg?.type == "Owner" && (
                    <div
                      onClick={() => setOpenImportModal(true)}
                      className="flex gap-2 items-center cursor-pointer"
                    >
                      <CiImport size={18} />
                      <p className="text-[14px]">Import</p>
                    </div>
                  )}
                  {currentOrg?.type == "Owner" && (
                    <div className="flex gap-2 items-center cursor-pointer">
                      <CiImport size={18} />
                      <p className="text-[14px]">Import ICS</p>
                    </div>
                  )}
                  <div
                    className="flex gap-2 items-center cursor-pointer"
                    onClick={() => setExportOpen(true)}
                  >
                    <CiExport size={18} />
                    <p className="text-[14px]">Export</p>
                  </div>
                  {/* {currentOrg?.type == "Owner" && (
                    <div className="flex gap-2 items-center cursor-pointer">
                      <IoSettingsOutline size={18} />
                      <p className="text-[14px]">Setting</p>
                    </div>
                  )} */}
                </Box>
              )}
              <span className="absolute left-1/2 -translate-x-1/2 w-[max-content] text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                More
              </span>
            </div>
          )}
        </div>
      </div>

      {switchScreen.primary === "calendarView" ? (
        <div>
          {/* Calendar Grid */}
          <div
            style={{
              backgroundColor: mode === "dark" ? "#141414" : "white",
              border: mode === "dark" ? "1px solid" : "1px solid #d7e2ed",
            }}
            className="grid grid-cols-7 gap-0 sm:p-2 text-center text-gray-700 font-medium"
          >
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
              <div key={day} className="sm:p-2 py-2">
                {day}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-0">
            {calendarDays.map((day, index) => {
              const fullDate = currentMonth.date(day);
              const dateString = fullDate.toDate().toDateString();
              const holidayNames = holidayDates.get(dateString) || [];

              return (
                <div
                  key={index}
                  onClick={() => setSelectedDate(fullDate)}
                  style={{
                    border:
                      mode === "dark"
                        ? "1px solid #374151"
                        : "1px solid #d7e2ed",
                  }}
                  className={`sm:h-32 p-3 ${mode === "dark" ? "bg-[#141414]" : "bg-white"
                    }`}
                >
                  {day && (
                    <>
                      <span
                        className={`text-[14px] sm:text-lg ${fullDate.date() === selectedDate.date() &&
                            currentMonth.isSame(selectedDate, "month")
                            ? "bg-blue-500 p-1 px-2 rounded-lg text-white font-bold"
                            : ""
                          } ${holidayNames.length > 0
                            ? "bg-green-500 text-white font-semibold rounded-full px-2"
                            : ""
                          }`}
                      >
                        {day}
                      </span>

                      {holidayNames.length > 0 && (
                        <div className="mt-1 space-y-1 text-center">
                          {holidayNames.map((name, i) => (
                            <div
                              key={i}
                              className={`text-[10px] border-2 rounded-lg border-blue-500 p-2 sm:text-xs ${mode === "dark" ? "text-white" : "text-black"
                                } font-medium`}
                            >
                              {name}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <></>
      )}

      {switchScreen.primary === "tableView" ? (
        filteredHolidays?.length > 0 ? (
          <TableContainer className="rounded-md overflow-x-auto h-[full] mt-[20px]">
            <Table>
              <TableHead>
                <TableRow
                  className={`${mode === "light" ? "bg-[#e7e9f3]" : "bg-transparent"
                    } `}
                >
                  <TableCell
                    className={`font-medium text-xs text-[#4a4a4a] ${mode === "light" ? "border-r border-[#f8f8f8]" : ""
                      }`}
                  >
                    Name
                  </TableCell>

                  <TableCell
                    className={`font-medium text-xs text-[#4a4a4a] ${mode === "light" ? "border-r border-[#f8f8f8]" : ""
                      }`}
                  >
                    Date
                  </TableCell>

                  <TableCell
                    className={`font-medium text-xs text-[#4a4a4a] ${mode === "light" ? "border-r border-[#f8f8f8]" : ""
                      }`}
                  >
                    Location
                  </TableCell>

                  <TableCell
                    className={`font-medium text-xs text-[#4a4a4a] ${mode === "light" ? "border-r border-[#f8f8f8]" : ""
                      }`}
                  >
                    Shifts
                  </TableCell>

                  <TableCell
                    className={`font-medium text-xs text-[#4a4a4a] ${mode === "light" ? "border-r border-[#f8f8f8]" : ""
                      }`}
                  >
                    Description
                  </TableCell>

                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredHolidays?.map((req) => (
                  <TableRow
                    className={`cursor-pointer group ${mode === "light" ? "hover:bg-[#eff0f1]" : ""
                      }`}
                    key={req._id}
                    onClick={() => {
                      if (currentOrg?.type == "Owner") {
                        setEditData(req);
                        setModalOpen(true);
                      }
                    }}
                  >
                    <TableCell
                      className={`text-sm text-[#000] ${mode === "light" ? "border-r border-[#fcfcfc]" : ""
                        }`}
                    >
                      <span className="">{req?.name}</span>
                    </TableCell>

                    <TableCell
                      className={`text-sm text-[#000] ${mode === "light" ? "border-r border-[#fcfcfc]" : ""
                        }`}
                    >
                      {req?.dateDetails?.map((date, i) => {
                        const d = new Date(date?.date);
                        const options = {
                          weekday: "short",
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        };
                        const formatted = d.toLocaleDateString(
                          "en-GB",
                          options
                        ); // "Wed, 07 May 2025"
                        const [weekday, rest] = formatted.split(", ");
                        const datePart = rest.replace(/ /g, "-");

                        return (
                          <div key={i}>
                            {datePart},{" "}
                            <span className="text-[#97948e] font-medium">
                              {weekday}
                            </span>
                          </div>
                        );
                      })}
                    </TableCell>

                    <TableCell
                      className={` ${mode === "light" ? "border-r border-[#fcfcfc]" : ""
                        }`}
                    >
                      {req?.criteria?.map((loc, i) => (
                        <span key={i}>{loc?.value || "N/A"}</span>
                      ))}
                    </TableCell>

                    <TableCell
                      className={` ${mode === "light" ? "border-r border-[#fcfcfc]" : ""
                        }`}
                    >
                      -
                    </TableCell>
                    <TableCell
                      className={` ${mode === "light" ? "border-r border-[#fcfcfc]" : ""
                        }`}
                    >
                      {req?.description}
                    </TableCell>
                    {currentOrg?.type == "Owner" && (
                      <TableCell
                        className={` ${mode === "light" ? "border-r border-[#fcfcfc]" : ""
                          }`}
                      >
                        <div
                          className="flex gap-2 items-center opacity-0 justify-center 
                    group-hover:opacity-100 transition-opacity duration-200"
                        >
                          <MdOutlineEdit
                            onClick={(e) => {
                              e.stopPropagation();
                              setAddHolidayModel(true);
                              setModalOpen(false);
                              setEditData(req);
                            }}
                          />
                          <div>
                            <RiDeleteBin6Line
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteModalOpen(true);
                                setSelectedHolidayId(req?._id);
                                setModalOpen(false);
                              }}
                            />
                          </div>
                        </div>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div className="flex justify-center items-center h-60">
            <div>No holiday found </div>
          </div>
        )
      ) : null}

      <AddHolidayModal
        addHolidayModal={addHolidayModal}
        setAddHolidayModel={setAddHolidayModel}
        editData={editData}
      />

      <ExportModal
        open={exportOpen}
        handleClose={() => setExportOpen(false)}
        tableData={exportData}
      />
      <ImportModal
        open={openImportModal}
        handleDone={handleDone}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        handleClose={handleClose}
      />

      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <div className="relative">
          <IconButton
            onClick={() => setDeleteModalOpen(false)}
            style={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle className="flex flex-col items-center pt-8">
            <WarningAmberRoundedIcon
              style={{ color: "#F44336", fontSize: 40 }}
            />
            <p variant="h6" fontWeight="bold" mt={1}>
              Delete holiday?
            </p>
          </DialogTitle>

          <DialogContent>
            <p
              className={`text-[14px] ${mode === "light" ? "text-[#4d4d4d]" : "text-[#fff]"
                } mb-4`}
            >
              This action will delete all data of this holiday and it cannot be
              retrieved
            </p>

            <FormControlLabel
              control={<Checkbox />}
              label="Notify applicable employees via feeds"
              className="text-[14px]"
            />

            <FormControlLabel
              control={<Checkbox />}
              label={
                <div>
                  <p
                    className={`text-[14px] ${mode === "light" ? "text-[#222222]" : "text-[#fff]"
                      }`}
                  >
                    Reprocess leave applications based on this deleted holiday
                  </p>
                  <p
                    className={`text-[14px] ${mode === "light" ? "text-[#4d4d4d]" : "text-[#fff]"
                      }`}
                  >
                    (Leaves that are already applied for this holiday will be
                    reprocessed and the balance will be adjusted accordingly)
                  </p>
                </div>
              }
            />
          </DialogContent>

          <div className="justify-center flex gap-2 pb-4">
            <Button
              variant="contained"
              // color="error"
              // onClick={onConfirm}
              sx={{
                textTransform: "none",
                padding: "6px 24px",
                backgroundColor: "#EC5158",
              }}
              onClick={handleConfirmDelete}
            >
              Confirm
            </Button>
            <Button
              onClick={() => setDeleteModalOpen(false)}
              sx={{
                textTransform: "none",
                padding: "6px 24px",
                border: "1px solid #eaeaea",
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Dialog>

      <FilterDrawer />

      <ViewModal
        open={modalOpen}
        data={editData}
        setModalOpen={setModalOpen}
        onClose={() => setModalOpen(false)}
        onEdit={() => {
          setEditData(editData);
          setAddHolidayModel(true);
          setModalOpen(false);
        }}
      />
    </div>
  );
}
